import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import React from "react";

import BlogFeedPostsWithLoadMore from "@/mk2/apps/blogs/components/BlogFeedPostsWithLoadMore";
import { BLOGS_POPULAR_FEED_FETCH_TRIGGER } from "@/mk2/apps/blogs/containers/BlogsPopularFeed/BlogsPopularFeed.actions";
import { groupsListUrl } from "@/mk2/apps/groups/urls";
import { Btn, BtnType } from "@/mk2/components/Btn";
import { Failure } from "@/mk2/components/errors/Failure";
import { LoadingSwitch } from "@/mk2/containers/LoadingSwitch/LoadingSwitch";
import { BACK_TO_LIST_OF_GROUPS } from "@/mk/autogenerated/translation";
import { urlize } from "@/mk/bazaar/common/filters";

import styles from "./BlogsPopularFeed.mscss";
import { Props } from "./BlogsPopularFeedPage";

class BlogsPopularFeed extends React.Component<Props> {
    public render() {
        const { loadingState, feedItems } = this.props;

        return (
            <div className={styles.BlogsPopularFeed}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderInit={this.renderInitOrSuccess}
                    onRenderSuccess={this.renderInitOrSuccess}
                    onRenderFailure={this.renderFailure}
                    hasData={feedItems && feedItems.length > 0}
                />
            </div>
        );
    }

    private load = () => {
        const { onLoad, onLoadUserGroupMemberships } = this.props;
        onLoad();
        onLoadUserGroupMemberships();
    };

    private renderFailure = () => {
        const { staticContext, errorMessage } = this.props;

        return (
            <Failure
                errorMessage={errorMessage}
                staticContext={staticContext}
                backButton={
                    <Btn
                        type={BtnType.Blue}
                        label={BACK_TO_LIST_OF_GROUPS}
                        icon={faArrowLeft}
                        link={groupsListUrl}
                    />
                }
                onRetry={this.load}
            />
        );
    };

    private renderInitOrSuccess = () => {
        const {
            commentsCounts,
            complaintsCounts,
            complaintsOpened,
            errorMessage,
            feedItems,
            hasMore,
            isMobile,
            loadingState,
            location,
            history,
            membershipsInGroups,
            onDelete,
            onIgnoreUser,
            onLoad,
            onPostToggleMenuMore,
            onPostToggleVisibilityMenuMore,
            onReport,
            onSetDisplayingAtFeed,
            onSetVisibility,
            requestUser,
            requestUserPermissions,
            staticContext,
            userAgent,
        } = this.props;

        return (
            <React.Fragment>
                <div id="scrolltoFirstHere" />{" "}
                {/* musi byt vzdy vyrenderovane v DOMe, pouziva sa zo sagy */}
                <BlogFeedPostsWithLoadMore
                    commentsCounts={commentsCounts}
                    complaintsCounts={complaintsCounts}
                    complaintsOpened={complaintsOpened}
                    errorMessage={errorMessage}
                    feedItems={feedItems}
                    hasMore={hasMore}
                    isMobile={isMobile}
                    loadingState={loadingState}
                    location={location}
                    history={history}
                    membershipsInGroups={membershipsInGroups}
                    onDelete={onDelete}
                    onIgnoreUser={onIgnoreUser}
                    onLoad={onLoad}
                    onPostToggleMenuMore={onPostToggleMenuMore}
                    onPostToggleVisibilityMenuMore={onPostToggleVisibilityMenuMore}
                    onReport={onReport}
                    onSetDisplayingAtFeed={onSetDisplayingAtFeed}
                    onSetVisibility={onSetVisibility}
                    requestUser={requestUser}
                    requestUserPermissions={requestUserPermissions}
                    showStrips
                    staticContext={staticContext}
                    triggerActionOfLoadMoreButton={BLOGS_POPULAR_FEED_FETCH_TRIGGER}
                    userAgent={userAgent}
                />
                <div id="scrolltoLastHere" />{" "}
                {/* musi byt vzdy vyrenderovane v DOMe, pouziva sa zo sagy */}
            </React.Fragment>
        );
    };
}

export default BlogsPopularFeed;
